export default __webpack_public_path__ + "static/media/Elder Wand - Img - Final (2)_01.7314542b.jpg";